module.exports = __webpack_public_path__ + "img/g1.cb98dccb.jpg";